import { cloneDeep } from 'lodash'
import AppBridge from '../bridge'
import { isUnityUA } from '../uaConfig'
import { slsUnitySend } from './slsUnity'

export type SLSEventDataType = {
  'activity_id': string // 活动ID
  position: number// 位置 0 房间外;1 房间内
  state: number // 状态
  'like_state': number // 点赞状态
  'error_code': number // 错误信息
  uid: string
  'number_messages': string // 浏览的留言条数
}

export type SLSEventData = {
  page: string
  'event_name': string
  data: Partial<SLSEventDataType>
}

export function slsAppSend() {
  const userAgent = navigator.userAgent.toLowerCase()

  const slsSendEvent = (data: SLSEventData) => {
    if (isUnityUA(userAgent)) {
      slsUnitySend().slsSendEvent(data)
    } else {
      const params = cloneDeep(data.data)
      params.position = 0
      // 安卓orIOS
      AppBridge({
        method: 'statEvent',
        data: {
          eventId: data.event_name,
          event_source: 'h5',
          page: data.page,
          uploadFlag: 2,
          params: params
        },
        callBack: false,
        module: ''
      })
    }
  }

  return { slsSendEvent }
}
